import React from 'react';
import PropTypes from 'prop-types';
import { generateClassName } from '../../../../_modules/helper/generate_class_name';
import { hasTruthy } from '../../../../_modules/helper/has_truthy';

const lazyClassNames = generateClassName({
    'sidebar__row-container': true,
    'sidebar__row-container--has-fitting': hasTruthy('hasFitting')
});

export const Table = props => (
    <table className={lazyClassNames(props)}>
        <tbody>
            {props.rows}
        </tbody>
    </table>
);

Table.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.bool,
        ])
    ).isRequired,
    hasFitting: PropTypes.bool,
};

Table.defaultProps = {
    hasFitting: false,
};
